import React, { ReactNode, createContext, useContext } from "react";
import { useAddNewMachineDrawerModal } from "./use-add-new-machine-drawer-modal-hook";

type AddNewMachineDrawerModalContextType = ReturnType<
  typeof useAddNewMachineDrawerModal
>;

const AddNewMachineDrawerModalContext =
  createContext<AddNewMachineDrawerModalContextType | null>(null);

interface AddNewMachineDrawerModalProviderProps {
  children: ReactNode;
  value: AddNewMachineDrawerModalContextType;
}

export const AddNewMachineDrawerModalProvider = ({
  children,
  value,
}: AddNewMachineDrawerModalProviderProps) => {
  return (
    <AddNewMachineDrawerModalContext.Provider value={value}>
      {children}
    </AddNewMachineDrawerModalContext.Provider>
  );
};

export const useAddNewMachineDrawerModalContext = () => {
  const context = useContext(AddNewMachineDrawerModalContext);
  if (!context) {
    throw new Error(
      "useAddNewMachineDrawerModalContext must be used within AddNewMachineDrawerModalProvider",
    );
  }

  return context;
};
